// extracted by mini-css-extract-plugin
export default {"arrbtn":"SkillsforYou_arrbtn__QsIuw","hdskl":"SkillsforYou_hdskl__Zedzc","hdskl1":"SkillsforYou_hdskl1__7vStU","hdskl2":"SkillsforYou_hdskl2__zB0EX"};